import { IsInpatientPrescription, OnlinePharmacy } from "./fields";
export const Consultation = { IsInpatientPrescription, OnlinePharmacy };
